import React, { useState } from 'react';
import { Navigation, History } from 'lucide-react';
import LiveTrackingMap from './LiveTrackingMap';
import WorkerActivityLog from './WorkerActivityLog';

// Single "Tracking" screen. Two views behind one menu item:
//   • Live         → real-time map of workers on shift + the full route travelled so far
//   • Shift Routes → permanent history: pick a worker/date → whole-shift road route, stops, km
// (Mileage is intentionally kept separate — it is a billing feature, not GPS tracking.)
export default function TrackingHub({ initialTab = 'live' }) {
  const [tab, setTab] = useState(initialTab === 'routes' ? 'routes' : 'live');

  return (
    <div className="flex flex-col h-full bg-slate-50">
      {/* View toggle */}
      <div className="flex items-center gap-1 px-4 py-2.5 bg-white border-b border-slate-200 shrink-0">
        <TabBtn active={tab === 'live'}   onClick={() => setTab('live')}   icon={Navigation} label="Live" />
        <TabBtn active={tab === 'routes'} onClick={() => setTab('routes')} icon={History}    label="Shift Routes" />
      </div>

      {/* Active view */}
      <div className="flex-1 min-h-0">
        {tab === 'live'
          ? <div className="h-full"><LiveTrackingMap /></div>
          : <div className="h-full overflow-y-auto"><WorkerActivityLog /></div>}
      </div>
    </div>
  );
}

function TabBtn({ active, onClick, icon: Icon, label }) {
  return (
    <button
      onClick={onClick}
      className={`flex items-center gap-1.5 text-sm font-600 px-3.5 py-1.5 rounded-lg transition-colors ${
        active ? 'bg-primary-50 text-primary-700' : 'text-slate-500 hover:bg-slate-100'
      }`}
    >
      <Icon size={15} /> {label}
    </button>
  );
}
